import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Apart from "./sections/Apart";
import Touch from "./sections/Touch";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Story />
      <Apart />
      <Touch />
      <Footer />
    </div>;
}